// export const BASE_API = "http://localhost:5000/api/v1";
export const BASE_API = "https://settyl-api.up.railway.app/api/v1";